/** Empirical age/sex percentiles, Table 2 (L/min). No interpolated percentiles,
 * individual predictions or clinical LLN are inferred from these observations.
 * Bianchi C, Baiardi P. Am J Phys Med Rehabil. 2008;87:461–467.
 * https://doi.org/10.1097/PHM.0b013e318174e4c7
 */
export const BIANCHI_2008_PCF_PERCENTILES: Readonly<Record<'female' | 'male', Readonly<Record<number, readonly [number, number, number]>>>> = {
  female: {
    4: [110, 147, 209], 5: [125, 185, 273], 6: [161, 230, 317], 7: [179, 247, 330], 8: [200, 299, 351],
    9: [270, 311, 369], 10: [270, 330, 399], 11: [296, 380, 478], 12: [305, 399, 459], 13: [311, 395, 545],
    14: [361, 428, 561], 15: [344, 469, 596], 16: [358, 469, 626], 17: [369, 469, 633], 18: [399, 488, 639],
  },
  male: {
    4: [130, 162, 230], 5: [138, 194, 270], 6: [166, 226, 293], 7: [200, 270, 351], 8: [215, 299, 347],
    9: [217, 311, 424], 10: [250, 321, 428], 11: [290, 369, 441], 12: [311, 369, 498], 13: [321, 450, 578],
    14: [380, 608, 750], 15: [380, 633, 829], 16: [493, 652, 871], 17: [498, 645, 944], 18: [518, 728, 944],
  },
};

/** Table 1: [age, male mean, male SD, female mean, female SD], n=10 per
 * sex/age. The individual outcome is the arithmetic mean of THREE coughs.
 * These are descriptive sample means, not individual predicted values or LLN.
 * Cardoso FEF et al. Int Arch Med. 2012;5:25.
 * https://pmc.ncbi.nlm.nih.gov/articles/PMC3499384/
 */
export const CARDOSO_2012_PCF_MEANS: readonly (readonly [number, number, number, number, number])[] = [
  [18, 499, 51, 355, 31], [19, 486, 48, 320, 29], [20, 484, 47, 327, 34], [21, 435, 49, 314, 28],
  [22, 428, 36, 313, 25], [23, 407, 39, 313, 34], [24, 406, 43, 302, 33], [25, 494, 34, 302, 31],
  [26, 486, 37, 310, 30], [27, 484, 45, 304, 24], [28, 439, 35, 298, 23], [29, 430, 41, 297, 31],
  [30, 426, 44, 296, 38], [31, 410, 39, 286, 25], [32, 399, 32, 295, 36], [33, 380, 41, 285, 21],
  [34, 380, 33, 282, 29], [35, 376, 32, 280, 34], [36, 381, 43, 278, 35], [37, 360, 33, 279, 21],
  [38, 347, 49, 262, 30], [39, 337, 39, 258, 23], [40, 316, 38, 242, 34],
];
